import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { validationsList_template } from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {header} from "./header";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {configSidebar_template} from "../components/templates/configSidebar_template";
import {configSidebar_vignettePicker_helper} from "./configSidebar_vignettePicker_helper";
import * as classicEditor from "@ckeditor/ckeditor5-build-classic";

declare var ko: any;
declare var page: any;

export class config_sidebar extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected configSidebar: configSidebar_template;
    protected vignettePickerHelper: configSidebar_vignettePicker_helper;
    protected validationsList: validationsList_template;
    protected listingPageIdElement: string = 'filterListingPageTemplate';
    protected _isLeavePageWarningNeeded: boolean = true;
    private pollXhr: XMLHttpRequestHandler;
    protected textAreaEditor;
    protected CKEDITOR_CONFIG = {
        toolbar: ["bold", "|", "italic", "link"],
    };

    protected getModuleName(){
        return "config_sidebar";
    }

    buildContent() : Element[]{

        this.configSidebar = new configSidebar_template( "configSidebar", this.viewModel, this );
        this.vignettePickerHelper = new configSidebar_vignettePicker_helper(
            this.configSidebar.vignettePicker,
            this.getVnAppZone(),
            this,
            (vignette) => this.selectSidebarVignette(vignette)
        );
        this.configSidebar.vignettePicker.vignettePickerInsertForm_template.setSingleInsertMode(true);
        this.configSidebar.vignettePicker.vignettePickerInsertForm_template.setHideDestinationContextOptions(true);
        this.configSidebar.vignettePicker.setCaller(this.vignettePickerHelper);
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Config Sidebar");

        return [ this.configSidebar.build()];
    }

    public openSidebarVignettePicker(): void {
        this.configSidebar.vignettePicker.showVignettePicker(null);
    }

    protected selectSidebarVignette(vignette: any): void {
        if (!vignette || !vignette.id) {
            return;
        }

        this.configSidebar.selectSidebarVignette(vignette);
    }

    public fillPage() : void{

        this.configSidebar.buildWidgetDatePickerCalendar();
        this.getPinnedWidget();
    }

    protected getConfigSettings(){

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let usrReq_url: string = '/api/brand/' + idBrand + "/config/sidebar/get/";
        let usrReq_params: Array<Array<string>> = [];

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetConfigSettingsReturn;
        this.XHRHdl.execute();
    }
    protected onGetConfigSettingsReturn(req,obj){
        return function(){
            obj.manageResponse(req, obj, function() {
                let responseParsed = JSON.parse(req.request.response);

                if (responseParsed.sidebar_general) {

                    let generalConfig = JSON.parse(responseParsed.sidebar_general.value)
                    obj.configSidebar.isPopularSectionEnabledOnHomePage(generalConfig.isPopularSectionEnabledOnHomePage);
                    obj.configSidebar.isPopularSectionEnabledOnArticlePage(generalConfig.isPopularSectionEnabledOnArticlePage);
                    obj.configSidebar.isTrendingNowWithTagInteractionOnArticlePage(generalConfig.isTrendingNowWithTagInteractionOnArticlePage);
                    obj.configSidebar.isPopularSectionEnabledOnListingPage(generalConfig.isPopularSectionEnabledOnListingPage);
                    obj.configSidebar.isTrendingNowSectionEnabledOnHomePage(generalConfig.isTrendingNowSectionEnabledOnHomePage);
                    obj.configSidebar.isTrendingNowSectionEnabledOnArticlePage(generalConfig.isTrendingNowSectionEnabledOnArticlePage);
                    obj.configSidebar.isTrendingNowSectionEnabledOnListingPage(generalConfig.isTrendingNowSectionEnabledOnListingPage);
                }

                if (responseParsed.sidebar_pinned_listing_page) {

                    let pinnedLpConfig = JSON.parse(responseParsed.sidebar_pinned_listing_page.value)
                    obj.configSidebar.isPinnedListingPageEnabledOnHomePage(pinnedLpConfig.isEnabledOnHomePage);
                    obj.configSidebar.isPinnedListingPageEnabledOnArticlePage(pinnedLpConfig.isEnabledOnArticlePage);
                    obj.configSidebar.isPinnedListingPageEnabledOnListingPage(pinnedLpConfig.isEnabledOnListingPage);
                }

                if (responseParsed.sidebar_pinned_widgets) {

                    let pinnedWidgetConfig = JSON.parse(responseParsed.sidebar_pinned_widgets.value)
                    obj.configSidebar.isPinnedWidgetEnabledOnHomePage(pinnedWidgetConfig.isEnabledOnHomePage);
                    obj.configSidebar.isPinnedWidgetEnabledOnArticlePage(pinnedWidgetConfig.isEnabledOnArticlePage);
                    obj.configSidebar.isPinnedWidgetEnabledOnListingPage(pinnedWidgetConfig.isEnabledOnListingPage);
                }

                obj.configSidebar.setCategoryFilterItems(responseParsed.categories);

                if (responseParsed.sidebar_pinned_articles) {

                    const pinnedArticleConfig = JSON.parse(responseParsed.sidebar_pinned_articles.value)
                    obj.configSidebar.isPinnedArticleEnabledOnHomePage(pinnedArticleConfig.isEnabledOnHomePage);
                    obj.configSidebar.isPinnedArticleEnabledOnArticlePage(pinnedArticleConfig.isEnabledOnArticlePage);
                    obj.configSidebar.isPinnedArticleEnabledOnListingPage(pinnedArticleConfig.isEnabledOnListingPage);
                    if (pinnedArticleConfig.articles && pinnedArticleConfig.articles.length) {
                        obj.configSidebar.setPinnedArticles(pinnedArticleConfig.articles);
                    }
                }


                obj.configSidebar.setPermissions(responseParsed.permissions);
                obj.initCkEditor();
                obj.loadingOut(obj.configSidebar.builtTemplate);
            })
        }
    }
    protected getPinnedWidget(){

        this.loadingIn(this.configSidebar.builtTemplate);

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let usrReq_url: string = '/api/brand/' + idBrand + "/config/sidebar/pinned-widget/get/";
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetPinnedWidgetReturn;
        this.XHRHdl.execute();
    }

    protected onGetPinnedWidgetReturn(req, obj){

        return function(){
            obj.manageResponse(req, obj, function() {
                let responseParsed = JSON.parse(req.request.response);

                obj.configSidebar.setPinnedWidget(responseParsed.widgets);
                if (responseParsed.config && responseParsed.config.value) {
                    let configValue = JSON.parse(responseParsed.config.value);
                    obj.configSidebar.isPinnedWidgetEnabledOnHomePage(configValue.isEnabledOnHomePage);
                    obj.configSidebar.isPinnedWidgetEnabledOnArticlePage(configValue.isEnabledOnArticlePage);
                    obj.configSidebar.isPinnedWidgetEnabledOnListingPage(configValue.isEnabledOnListingPage);
                }

                obj.getPinnedListingPages();

            })
        }
    }

    public triggerNotification(message: string): void {
        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, message);
        this.getVnAppZone().showNotificationToModule();
    }

    public cancelForm() {
        this.cancelPinnedPageConfig();
        this.pinWidgetCancel();
        page.redirect(this.getVnAppZone().app.getLastRoute());
    }

    protected cancelPinnedPageConfig() {

        this.getPinnedListingPages();

        this.triggerNotification("Pinned Hub Pages Cancelled!");
    }

    public getPinnedListingPages(): void {

        if(this.XHRHdl){
            this.XHRHdl.cancelAndReset();
        }

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand  + "/config/listing-pages/sidebar/pinned/get/";
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetPinnedListingPagesReturn;
        this.XHRHdl.execute();
    }

    protected onGetPinnedListingPagesReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let response = JSON.parse(req.request.response);

                if (response) {

                    obj.configSidebar.setPinnedListingPages(response);
                    if (response.length == 0) {
                        obj.getPinnedCustomPages();
                    }
                }
                obj.getConfigSettings();
            });
        }
    }

    protected saveGeneralConfig(){

        this.loadingIn(this.configSidebar.builtTemplate);
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let formReq_url: string = '/api/brand/' + idBrand + "/config/sidebar/save/";
        let formReq_params: Array<Array<string>> = [];
        let subViewModel = this.configSidebar.getGeneralConfigViewModel();

        formReq_params.push(["data", ko.toJSON(subViewModel)] );

        let XHRHdl:XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url,formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function(req, obj){

            return function() {
                obj.manageResponse(req, obj, function(){
                    obj.getPinnedWidget();
                    let responseParsed = JSON.parse(req.request.response);

                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Sidebar Config saved successfully!");
                    obj.getVnAppZone().showNotificationToModule();

                })
            }
        });
        XHRHdl.execute();
    }
    
    protected savePinnedArticleConfig(){

        this.loadingIn(this.configSidebar.builtTemplate);
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let formReq_url: string = '/api/brand/' + idBrand + "/config/sidebar/pinned-article/save/";
        let formReq_params: Array<Array<string>> = [];
        let subViewModel = this.configSidebar.getPinnedArticleConfigViewModel();

        formReq_params.push(["data", ko.toJSON(subViewModel)] );

        let XHRHdl:XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url,formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function(req, obj){

            return function() {

                obj.manageResponse(req, obj, function(){
                    obj.getPinnedWidget();
                    let responseParsed = JSON.parse(req.request.response);

                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Pinned Article Config saved successfully!");
                    obj.getVnAppZone().showNotificationToModule();

                })
            }
        });
        XHRHdl.execute();
    }

    protected savePinnedWidget(){

        this.loadingIn(this.configSidebar.builtTemplate);

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let formReq_url: string = '/api/brand/' + idBrand + "/config/sidebar/pinned-widget/save/";

        let formReq_params: Array<Array<string>> = [];

        let subViewModel = this.configSidebar.getPinnedWidgetViewModel();

        formReq_params.push(["data", ko.toJSON(subViewModel)] );

        let XHRHdl:XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url,formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function(req, obj){

            return function() {
                if (req.request.readyState === 4 && req.request.status === 400) {
                    const responseParsed = JSON.parse(req.request.response || '{}');
                    obj.loadingOut(obj.configSidebar.builtTemplate);
                    obj.getVnAppZone().notification = new vn_app_zone_notification(
                        vn_app_zone_notification.TYPE_ERROR,
                        responseParsed.message || 'Select a valid sidebar widget.'
                    );
                    obj.getVnAppZone().showNotificationToModule();
                    return;
                }

                obj.manageResponse(req, obj, function(){
                    obj.getPinnedWidget();
                    let responseParsed = JSON.parse(req.request.response);

                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Pinned Widget saved successfully!");
                    obj.getVnAppZone().showNotificationToModule();

                })
            }
        });
        XHRHdl.execute();



    }

    protected savePinnedPageConfig() {

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        this.configSidebar.activateLoading();

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let formReq_url: string = '/api/brand/' + idBrand + "/config/listing-pages/sidebar/pinned/save/";

        let formReq_params: Array<Array<string>> = [];


        formReq_params.push(["data", ko.toJSON(this.configSidebar.getListingPagesConfigViewModel())]);

        this.XHRHdl = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {
                    obj.getPinnedListingPages();
                    //let responseParsed = JSON.parse(req.request.response);

                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Sidebar Config saved successfully !");
                    obj.getVnAppZone().showNotificationToModule();

                })
                // LOADING : ends
                obj.configSidebar.deactivateLoading();
            }
        });
        this.XHRHdl.execute();


    }

    protected pinWidgetCancel () {

        this.getPinnedWidget();
        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "Pinned Widget Cancelled!");
        this.getVnAppZone().showNotificationToModule();
    }

    public cancelPinnedWidget(): void {
        this.pinWidgetCancel();
    }

    protected getArticlesSuggestion(keyword, idElement) {

        let subViewModel = {list: {keyword: keyword}, idElement: idElement};
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/search/article/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetArticlesSuggestionsReturn;
        this.XHRHdl.execute();
    }

    protected onGetArticlesSuggestionsReturn(req, obj) {

        return function () {

            if (req.request.readyState == 4) {

                let responseParsed = JSON.parse(req.request.response);

                if (req.request.status == 200) {
                    if (responseParsed.data.articles) {
                        let x = responseParsed.data.idElement;

                        obj.configSidebar.setFilterAutocomplete(responseParsed.data.idElement, responseParsed.data.articles);
                    }
                } else if (req.request.status == "423") {
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, responseParsed.message);
                    obj.getVnAppZone().showNotificationToModule();
                } else {
                    obj.configSidebar.onUpdateError(req.request.status, responseParsed);
                }

                // LOADING : ends
                obj.configSidebar.deactivateLoading();
            }
        }
    }

    protected filterSimpleOnChange(idElement) {

        /*console.log(idElement);
        switch (idElement) {
            case 'filterListingPageTemplate':
            case 'filterSowMoreListingPageTemplate':
                break;
            default:
                this.configSidebar.setPinnedArticle(idElement);
        }*/

    }

    public getListingPageIdElement(): string {

        return this.listingPageIdElement;
    }

    public setListingPageIdElement(idElement: string): void {
        this.listingPageIdElement = idElement;
    }

    public getListingPagesSuggestion(keyword, idElement): void {

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        this.setListingPageIdElement(idElement);


        let subViewModel = {pagination: {itemPerPage: 25}, filter: {keyword: keyword}, idElement: idElement};
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/config/listing-pages/search/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetListingPagesSuggestionReturn;
        this.XHRHdl.execute();
    }

    protected onGetListingPagesSuggestionReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let response = JSON.parse(req.request.response);

                if (response.data.listingPages) {

                    obj.configSidebar.setFilterListingPagesAutoComplete(response.data.listingPages, obj.getListingPageIdElement());
                }
            });
        }
    }

    public searchWidget(keyword: string, widgetType: string) {
        if(keyword.length < 3) return;

        if(this.pollXhr){
            this.pollXhr.cancelAndReset();
        }
        const idBrand = this.getVnAppZone().app.params.idBrand;
        let url = '';
        let params = [];
        let mode = XMLHttpRequestHandler_requestType.GET;

        switch (widgetType) {
            case 'quiz':
                url = `/api/brand/${idBrand}/quizzes/search/`;
                params.push(['keyword', keyword]);
                break;
            case 'vignette':
                url = `/api/brand/${idBrand}/config/sidebar/pinned-widget/vignettes/search/`;
                params.push(['data', ko.toJSON({filter: {keyword}, pagination: {itemPerPage: 20, pageNumber: 1}})]);
                mode = XMLHttpRequestHandler_requestType.POST;
                break;
            default:
                url = `/api/brand/${idBrand}/polls/search/`;
                params.push(['keyword', keyword]);
                mode = XMLHttpRequestHandler_requestType.POST;
                break;
        }

        this.pollXhr = new XMLHttpRequestHandler(url, params, this);
        this.pollXhr.mode = mode;
        this.pollXhr.onReadyStateFunction = (req, obj) => {
            return () => {
                obj.manageResponse(req, obj, function () {
                    if (req.request.readyState == 4 && req.request.status == 200) {
                        const response = JSON.parse(req.request.response);
                        let options = [];
                        if (widgetType === 'quiz') {
                            options = response.map((quiz: {id: number, title: string}) => ({id: quiz.id, name: quiz.title}));
                        } else if (widgetType === 'vignette') {
                            options = (response.data || []).map((vignette: {id: number, name: string}) => ({id: vignette.id, name: vignette.name}));
                        } else {
                            options = response.map((poll: {id: number, name: string, dateClosed: string}) => ({id: poll.id, name: poll.name, dateClosed: poll.dateClosed}));
                        }
                        obj.configSidebar.setWidgetOptions(options);
                    }else{
                        console.error(req.request.response);
                        return [];
                    }
                });
            };
        };
        this.pollXhr.execute();
    }

    protected initCkEditor() {

        if (this.textAreaEditor) {
            return;
        }

        const textArea = document.getElementById("customCardDescription");
        if (!textArea) {
            return;
        }
    
        this.makeEditor(textArea).then((newEditor) => {
            this.textAreaEditor = newEditor;
        });
    }

    protected makeEditor(textArea: HTMLElement): Promise<any> {
        return classicEditor
            .create(textArea, this.CKEDITOR_CONFIG)
            .catch((error) => {
            console.error(error);
            });
    }

    public getPinnedCustomPages(): void {

        if(this.XHRHdl){
            this.XHRHdl.cancelAndReset();
        }

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand  + "/config/listing-pages/sidebar/pinned/custom-pages/get/";
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetPinnedCustomPagesReturn;
        this.XHRHdl.execute();
    }
    
    protected onGetPinnedCustomPagesReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let response = JSON.parse(req.request.response);

                if (response) {

                    obj.configSidebar.setPinnedCustomPages(response);
                }
            });
        }
    }

// ... existing code ...
    public filterMultipleSelectorOnChange(idElement: string): void {
        switch (idElement) {
            case 'article_categoryFilter':

                const selectedCategoryIds = this.configSidebar.filterCategory.getSelectedItems();
                const selectedCategories = this.configSidebar.getTemplateViewModel().categories().filter((category: any) =>
                    selectedCategoryIds.includes(category.id)
                );

                this.configSidebar.getTemplateViewModel().selectedCategories(selectedCategories);

                console.log('Filtered Categories:', selectedCategories);
                break;

            default:
                console.warn(`Unhandled filter ID: ${idElement}`);
        }
    }
// ... existing code ...
}



// WEBPACK FOOTER //
// ./js/modules/config_sidebar.ts